import { render, staticRenderFns } from "./DetailsActionAcceptReject.vue?vue&type=template&id=60a98c0d"
import script from "./DetailsActionAcceptReject.vue?vue&type=script&lang=js"
export * from "./DetailsActionAcceptReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports